import React from 'react';
import PropTypes from 'prop-types';
import * as styles from './styles/styles.module.scss';
import * as buttonStyles from '../buttons/styles/styles.module.scss';

/**
 * @deprecated use Button.js
 */
const FormButton = ({ value, disabled, className }) => {
  return (
    <input
      type="submit"
      data-testid="formButton-submit"
      disabled={disabled}
      className={`${buttonStyles.submit} ${styles.submit} ${className}`}
      value={value}
    />
  );
};

FormButton.propTypes = {
  value: PropTypes.string.isRequired,
  disabled: PropTypes.bool,
  className: PropTypes.string
};

FormButton.defaultProps = {
  disabled: false,
  className: ''
};

export default FormButton;
